var axios = require ('axios');

var axiosInstance = axios.create ({
	baseURL: process.env.BASE_ENDPOINT
});

module.exports = axiosInstance;
